export const isObjectEmpty = obj => Object.keys(obj).length === 0
